import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=500829de&scoped=true&"
import script from "./Objects.vue?vue&type=script&lang=js&"
export * from "./Objects.vue?vue&type=script&lang=js&"
import style0 from "./Objects.vue?vue&type=style&index=0&id=500829de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500829de",
  null
  
)

export default component.exports